import Slider from 'react-slick';
import NextArrow from 'components/Arrows/NextArrow';
import PrevArrow from 'components/Arrows/PrevArrow';
import type { CompanyRankingList } from 'api/fragments';
import { showRankValue } from 'utils/objectUtils';
import RankWithLabel from 'components/Globals/RankWithLabel';
import { addDots } from 'components/Globals/Dots';
import SectionTitle from 'components/Globals/SectionTitle';
import * as S from './AccoladesStyles';

export interface Props {
  rankings: CompanyRankingList[];
  companyTitle: string;
  titleDataCy?: string;
  wrapperDataCy?: string;
  rankDataCy?: string;
  labelDataCy?: string;
  linkDataCy?: string;
}

const Accolades = ({
  rankings,
  companyTitle,
  titleDataCy = '',
  wrapperDataCy = '',
  rankDataCy = '',
  labelDataCy = '',
  linkDataCy = '',
}: Props) => {
  const settings = {
    appendDots: addDots,
    arrows: true,
    centerMode: false,
    dots: true,
    infinite: false,
    lazyLoad: 'ondemand' as const,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: rankings.length === 1 ? 1 : 2,
        },
      },
    ],
    row: 1,
    slidesToScroll: rankings.length === 1 ? 1 : 2,
    slidesToShow: rankings.length === 1 ? 1 : 4,
    swipeToSlide: true,
  };

  return (
    <S.Wrapper data-cy={wrapperDataCy}>
      <SectionTitle
        titleDataCy={titleDataCy}
        tag='h2'
        text={`${companyTitle} in Fortune Rankings`}
        variant='border'
      />
      {rankings.length > 1 ? (
        <Slider {...settings}>
          {rankings.map(
            (ranking, index) =>
              ranking.rank <= 3000 && (
                <RankWithLabel
                  rankDataCy={`${rankDataCy}_${index}`}
                  labelDataCy={`${labelDataCy}_${index}`}
                  linkDataCy={`${linkDataCy}_${index}`}
                  rank={ranking.rank}
                  name={ranking.title}
                  key={ranking.slug}
                  uri={ranking.uri}
                  companyName={companyTitle}
                  showRank={showRankValue(ranking)}
                />
              ),
          )}
        </Slider>
      ) : (
        <RankWithLabel
          rank={rankings[0].rank}
          name={rankings[0].title}
          key={rankings[0].slug}
          uri={rankings[0].uri}
          className='ranking-single-item'
          showRank={showRankValue(rankings[0])}
          companyName={companyTitle}
        />
      )}
    </S.Wrapper>
  );
};

export default Accolades;
